module.exports = __webpack_public_path__ + "img/f04.78dcff6e.webp";